import React, { useState } from 'react'
import { Table, Button, Input } from 'semantic-ui-react'
import env from '../../../env'
import { useSelector } from 'react-redux'
import OrderItemDetailTwo from '../../../components/OrderItemDetail/OrderItemDetailTwo'

const BuyerQuotesRow = ({ rfq, onSubmit }) => {
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  const [quantity, setQuantity] = useState(rfq?.buyer_quantity || rfq?.order_item?.quantity || 0)
  const [price, setPrice] = useState(0)

  const handlePriceChange = (e, { value }) => {
    setPrice(value)
  }

  const handleQuantityChange = (e, { value }) => {
    setQuantity(value)
  }

  const handleSubmit = () => {
    onSubmit(rfq?.id, price, quantity)
  }

  return (
    <Table.Row className="quote-row">
      <Table.Cell>{rfq?.rfq?.rfq_number}</Table.Cell>
      <Table.Cell>
        <div className="product-details">
          <OrderItemDetailTwo
            orderItem={{
              product_variant: rfq?.product_variant,
            }}
          />
        </div>
      </Table.Cell>
      <Table.Cell>
        <Input name={'price'} value={price} onChange={handlePriceChange} />
      </Table.Cell>
      <Table.Cell>
        <Input
          name={'quantity'}
          value={quantity}
          onChange={handleQuantityChange}
        />{' '}
        / {rfq?.order_item?.quantity}
      </Table.Cell>
      <Table.Cell>{rfq?.buyer_uom?.short_name || rfq?.supplier_uom?.short_name}</Table.Cell>
      <Table.Cell>
        <Button
          onClick={handleSubmit}
          style={{
            '--primaryColor': tenant?.deployment_primary_color,
            '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
          }}
        >
          Submit Quote
        </Button>
      </Table.Cell>
    </Table.Row>
  )
}

export default BuyerQuotesRow
